/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export enum AttributeNames {
  TYPE = 'restify.type',
  NAME = 'restify.name',
  METHOD = 'restify.method',
  VERSION = 'restify.version',
}
